/**
 * NA-5172 — build-time env flag (`FEATURE_FLAG_APPROVING_INVOICE_REPORTS_RESPONSIVE_SEARCH`).
 * ON: the search form renders one antd Row with a Col per field (responsive).
 * OFF: today's three fixed-width Flex rows.
 */
export const APPROVING_SEARCH_RESPONSIVE_FLAG =
  'APPROVING_INVOICE_REPORTS_RESPONSIVE_SEARCH';
